import React from 'react';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { FormikNumericFormat } from '@klp/formgenerator/components/FormikNumericFormat';
import {
    handleFormikNumericFieldBlur,
    handleFormikNumericFieldChange,
} from '@forvalter/utils';
import type { KostnadskjemaUserInput } from '@klp/prosjekt/services/types';
import { useKostnadsKalkyleContext } from '../context/KostnadsKalkyleProvider';

type KostnadsKalkyleFormGeneralDataProps = {
    showLonnsomhetFields?: boolean;
};

const isPercentage = (v: { floatValue: number | undefined }) => {
    const { floatValue } = v;
    return floatValue === undefined || (floatValue >= 0 && floatValue <= 100);
};

export const KostnadsKalkyleFormGeneralData: React.FC<
    KostnadsKalkyleFormGeneralDataProps
> = () => {
    const { t } = useTranslation();
    const { isReadOnly } = useKostnadsKalkyleContext();
    const { handleChange } = useFormikContext<KostnadskjemaUserInput>();

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={6} sm={2}>
                <FormikNumericFormat
                    id="prosjektArealM2"
                    label={t('prosjekt.kostnadskalkyle.prosjektArealM2')}
                    variant="outlined"
                    align="right"
                    disabled={true}
                />
            </Grid>

            {/* Spacer: tilleggssatsene høyrestilles, adskilt fra prosjektarealet. */}
            <Grid item={true} xs={false} sm={4} />

            <Grid item={true} xs={6} sm={3}>
                <FormikNumericFormat
                    id="risikotilleggSats"
                    label={t('prosjekt.kostnadskalkyle.risikotilleggSats')}
                    variant="outlined"
                    align="right"
                    decimalScale={2}
                    disabled={isReadOnly}
                    isAllowed={isPercentage}
                    onChange={(e) =>
                        handleFormikNumericFieldChange(
                            handleChange,
                            e,
                            'risikotilleggSats',
                        )
                    }
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                        handleFormikNumericFieldBlur(e, handleChange);
                    }}
                />
            </Grid>

            <Grid item={true} xs={6} sm={3}>
                <FormikNumericFormat
                    id="prosjektlederSats"
                    label={t('prosjekt.kostnadskalkyle.prosjektlederSats')}
                    variant="outlined"
                    align="right"
                    decimalScale={2}
                    disabled={isReadOnly}
                    isAllowed={isPercentage}
                    onChange={(e) =>
                        handleFormikNumericFieldChange(
                            handleChange,
                            e,
                            'prosjektlederSats',
                        )
                    }
                    onFocus={(e) => e.target.select()}
                    onBlur={(e) => {
                        handleFormikNumericFieldBlur(e, handleChange);
                    }}
                />
            </Grid>
        </Grid>
    );
};
